<div class="portfolio-leader-hierarchy">
    <div class="table-container">
      <table mat-table [dataSource]="flattenedData" class="mat-elevation-z8" multiTemplateDataRows>
        <!-- Define Columns Dynamically -->
        <ng-container *ngFor="let col of COLUMNS" [matColumnDef]="col.key">
            <th mat-header-cell *matHeaderCellDef [style.width]="col.width" [style.text-align]="col.textAlign">
              <ng-container *ngIf="col.labelKey === 'cost'">
                <span class="cost-legend square-size" [style.background]="col.legendColor"></span>
              </ng-container>
              {{ col.label }}
            </th>
          
            <td mat-cell *matCellDef="let row" [style.text-align]="col.textAlign">
              <ng-container *ngTemplateOutlet="cellTemplate; context: { $implicit: row, column: col }"></ng-container>
            </td>
          </ng-container>
          
  
        <!-- Repeat for L2 -->
        <!-- <ng-container *ngFor="let col of COLUMNS" [matColumnDef]="col.key + '_L2'">
          <td mat-cell *matCellDef="let row" [style.text-align]="col.textAlign">
            <ng-container *ngTemplateOutlet="cellTemplate; context: { $implicit: row.L2, column: col }"></ng-container>
          </td>
        </ng-container> -->
  
        <!-- Repeat for L3 -->
        <!-- <ng-container *ngFor="let col of COLUMNS" [matColumnDef]="col.key + '_L3'">
          <td mat-cell *matCellDef="let row" [style.text-align]="col.textAlign">
            <ng-container *ngTemplateOutlet="cellTemplate; context: { $implicit: row.L3, column: col }"></ng-container>
          </td>
        </ng-container> -->
  
        <!-- Header and Rows -->
        <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
      </table>
    </div>
  </div>
  
  <!-- Cell Template -->
  <ng-template #cellTemplate let-row let-column="column">
    <ng-container [ngSwitch]="column.key">
      <ng-container *ngSwitchCase="'Emp_Name'">
        <div class="action-buttons">
          <span class="leader-result-level">{{ row?.level }}</span>
          {{ row?.label }}
        </div>
      </ng-container>
      <ng-container *ngSwitchCase="'Application'">
        <a *ngIf="row?.ucmg_count > 0" (click)="appsClicked(row)" class="link-click">
          {{ row?.ucmg_count }}
        </a>
      </ng-container>
      <ng-container *ngSwitchDefault>
        {{ row?.[column.key] || 0 }}
      </ng-container>
    </ng-container>
  </ng-template>
